module.exports = __webpack_public_path__ + "media/icons/printer-166b0ec1.svg";